import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { TemplatesSidebar } from '@/app/navigation/TemplatesSidebar';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The manufacturing database pages beside the Templates sidebar; their create, edit and duplicate pages stay outside.
export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<TemplatesSidebar />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
